<rb-dialog (buttonClick)="onDialogButtonClick($event)"
           (closeClick)="onClose()"
           (maximizedChange)="onMaximizedChange($event)"
           [(maximized)]="dialogMaximized"
           [config]="dialogConfig">
  <div class="flex gap-x-[4rem]">
    <rb-view-section class="w-[calc(100%-47.9rem)]">
      <ng-container *ngrxLet="processDocumentType$ | async as paymentDocumentType">
        <div *ngrxLet="processDocumentUrl$ | async as paymentDocumentUrl"
             [style.max-height]="docViewerMaxHeight"
             class="overflow-hidden rounded-[0.5rem] h-[100vh] w-full">
          <rb-image-viewer *ngIf="paymentDocumentType === 'image'"
                           alt="document"
                           class="block h-full w-full"
                           src="{{ paymentDocumentUrl }}"></rb-image-viewer>
          <rb-pdf-viewer *ngIf="paymentDocumentType === 'pdf'"
                         class="block h-full w-full"
                         src="{{ paymentDocumentUrl }}"></rb-pdf-viewer>
          <div *ngIf="!paymentDocumentUrl"
               class="flex flex-col justify-center items-center h-full">
            <mat-icon [class.icon-brand]="needsBrandColor(request.document.extension)"
                      [svgIcon]="fileIcon(request.document.extension)"
                      class="icon-40"></mat-icon>
          </div>
        </div>
      </ng-container>
    </rb-view-section>
    <form [formGroup]="form"
          class="flex flex-col gap-y-[2rem] w-[43.9rem]">
      <rb-document-name-bar (renamingChange)="onDocumentNameRenamingChange($event)"
                            [clientId]="request.document.client?.id"
                            [documentId]="request.document.id"
                            [extension]="request.document.extension"
                            [name]="request.document.name"></rb-document-name-bar>
      <div class="flex items-center gap-x-[1rem]">
        <mat-button-toggle-group *ngIf="(paymentFeatureEnabled$ | async) === true; else assignOnlyMode"
                                 [hideSingleSelectionIndicator]="true"
                                 class="flex-1"
                                 formControlName="mode"
                                 name="mode">
          <mat-button-toggle [disabled]="!request.paymentFormData"
                             class="w-[50%]" value="pay">
            <mat-icon svgIcon="payments"></mat-icon>
            <span>{{ 'APP.PROCESS_DOCUMENT_DIALOG.BUTTON.PAY.LABEL' | translate }}</span>
          </mat-button-toggle>
          <mat-button-toggle class="w-[50%]" value="assign">
            <mat-icon svgIcon="clients"></mat-icon>
            <span>{{ 'APP.PROCESS_DOCUMENT_DIALOG.BUTTON.ASSIGN.LABEL' | translate }}</span>
          </mat-button-toggle>
        </mat-button-toggle-group>
        <ng-template #assignOnlyMode>
          <button (click)="form.controls.mode.setValue('assign')"
                  [class.bg-brand]="form.controls.mode.value === 'assign'"
                  [class.border-brand]="form.controls.mode.value !== 'assign'"
                  [class.text-brand]="form.controls.mode.value !== 'assign'"
                  [class.text-inverted-primary]="form.controls.mode.value === 'assign'"
                  class="h-[3.33rem] flex-1 rounded-[1.5rem] border px-[1.6rem] py-[0.5rem]"
                  type="button">
            <span class="flex items-center justify-center gap-x-[1rem]">
              <mat-icon [class.icon-brand]="form.controls.mode.value !== 'assign'"
                        [class.icon-inverted-primary]="form.controls.mode.value === 'assign'"
                        class="icon-15" svgIcon="clients"></mat-icon>
              <span>{{ 'APP.PROCESS_DOCUMENT_DIALOG.BUTTON.ASSIGN.LABEL' | translate }}</span>
            </span>
          </button>
        </ng-template>
        <button (click)="form.controls.mode.setValue('delete')"
                [class.bg-negative]="form.controls.mode.value === 'delete'"
                class="h-[3.33rem] w-[3.5rem] flex items-center justify-center rounded-[1.5rem] border border-negative px-[1rem] py-[0.5rem]"
                type="button">
          <mat-icon [class.icon-negative]="form.controls.mode.value !== 'delete'"
                    class="icon-15"
                    svgIcon="delete"></mat-icon>
        </button>
      </div>
      <rb-edit-payment (fetchClientBeneficiaries)="fetchClientBeneficiaries($event)"
                       (saveBeneficiary)="saveBeneficiary($event)"
                       *ngIf="(paymentFeatureEnabled$ | async) === true"
                       [addPaymentEnabled]="false"
                       [addPaymentLoading]="addPaymentLoading$ | async"
                       [beneficiariesLoading]="beneficiariesLoading$ | async"
                       [beneficiaries]="beneficiaries$ | async"
                       [beneficiaryEditing]="beneficiaryEditing$ | async"
                       [class.hidden]="form.controls.mode.value !== 'pay'"
                       [clientInputDisabled]="false"
                       [errorKey$]="errorKey$"
                       [paymentAccounts]="paymentAccounts$ | async"
                       [paymentClients]="paymentClients$ | async"
                       [predictedClient]="request.predictedClient || null"
                       [singleColumn]="true"
                       [style.height]="paymentFormHeight"
                       class="overflow-y-auto"
                       formControlName="payment">
      </rb-edit-payment>
      <rb-select-client [class.hidden]="form.controls.mode.value !== 'assign'"
                        [clients]="assignDocumentClients$ | async"
                        [radioGroupHeight]="assignFormRadioGroupHeight"
                        formControlName="client"></rb-select-client>
      <div *ngIf="form.controls.mode.value === 'delete'"
           [style.height]="paymentFormHeight"
           class="flex items-center justify-center text-center">
        <div>
          <div class="font-bold text-negative">
            {{ 'APP.PROCESS_DOCUMENT_DIALOG.DELETE.TITLE' | translate }}
          </div>
        </div>
      </div>
    </form>
  </div>
</rb-dialog>
